export function withCache(fn) {
  var CACHE = new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var key = JSON.stringify(args);
    var cached = CACHE.get(key);
    if (cached) return cached;
    var value = fn(...args);
    CACHE.set(key, value);
    return value;
  };
}